import { motion } from 'framer-motion';
import { LogIn } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

export const ResetPasswordCompleteSuccess = () => {
  return (
    <motion.div
      key="password-reset-complete-success"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <div className="space-y-4">
        <Button className="w-full" asChild>
          <Link to="/login">
            <LogIn className="mr-2 h-4 w-4" />
            Login
          </Link>
        </Button>
      </div>
    </motion.div>
  );
};
